import React from 'react';

import { Chip } from '@infoods/lifebase-ui';
import {
  GoHighLevelAccountStatus,
  GO_HIGH_LEVEL_ACCOUNT_STATUS,
} from '../../../../constants/goHighLevelAccountStatus';

type AccountStatusChipProps = {
  status: GoHighLevelAccountStatus;
};

const AccountStatusChip = ({ status }: AccountStatusChipProps) => {
  switch (status) {
    case GO_HIGH_LEVEL_ACCOUNT_STATUS.ACTIVE:
      return <Chip label="Active" color="success" size="medium" />;
    case GO_HIGH_LEVEL_ACCOUNT_STATUS.NOT_AVAILABLE:
      return <Chip label="Not available" color="error" size="medium" />;
    default:
      return <div>No Info</div>;
  }
};

export { AccountStatusChip };
